import { SvgIcon, SvgIconProps } from "@mui/material";

export const C2PAIcon = ({ ...props }: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 17 18" {...props}>
			<g clip-path="url(#clip0_7006_27713)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.6321 9.12891V16.1556H8.60547C4.7238 16.1556 1.5788 13.0106 1.5788 9.12891C1.5788 5.24724 4.7238 2.10224 8.60547 2.10224C12.4871 2.10224 15.6321 5.24724 15.6321 9.12891ZM0.105469 9.12891C0.105469 4.43974 3.9163 0.628906 8.60547 0.628906C13.2946 0.628906 17.1055 4.43974 17.1055 9.12891V17.6289H8.60547C3.9163 17.6289 0.105469 13.8181 0.105469 9.12891ZM3.4913 9.46891C3.4913 11.2185 4.67422 12.6989 6.5513 12.6989C8.09547 12.6989 9.1438 11.6789 9.3988 10.3472H7.8688C7.67047 10.9564 7.18172 11.3318 6.5513 11.3318C5.60214 11.3318 4.9788 10.581 4.9788 9.46891C4.9788 8.35682 5.60214 7.60599 6.5513 7.60599C7.16047 7.60599 7.64922 7.95307 7.85463 8.53391H9.39172C9.12255 7.23057 8.0813 6.23891 6.5513 6.23891C4.66714 6.23891 3.4913 7.71932 3.4913 9.46891ZM11.4459 6.40891H10.0009V12.536H11.5026V9.34141C11.5026 8.73932 11.6726 8.34974 11.963 8.10182C12.218 7.87516 12.5509 7.75474 13.0963 7.75474H13.4788V6.33807H13.1034C12.3101 6.33807 11.7859 6.62849 11.4459 7.06766V6.40182V6.40891Z"
				/>
			</g>
		</SvgIcon>
	);
};
